import React from 'react';
import HeaderButton from "./button";
import {Dropdown} from "semantic-ui-react";

const HeaderDropdown = ({value, icon, onChange, options, withLeftLine, label, ...p}) => {
    const trigger = <HeaderButton
        icon={icon}
        name={label ? label : (options.find(o => o.value == value) || {}).text}
        withLeftLine={withLeftLine}
    />;

    // Исключаем options из пропсов если есть label
    const { options: _, ...restProps } = p;
    const dropdownProps = {
        ...restProps,
        className: `header-dropdown dropdown-style ${label ? 'with-label' : ''}`,
        onChange,
        value,
        trigger
    };
    
    // Добавляем options только если нет label
    if (!label) {
        dropdownProps.options = options;
    }

    return (
        <Dropdown {...dropdownProps}>
            {label && <Dropdown.Menu>
                {
                    options.map(o => <Dropdown.Item key={o.key} onClick={o.onClick}>
                        {o.text}
                    </Dropdown.Item>)
                }
            </Dropdown.Menu>}
        </Dropdown>
    );
};

export default HeaderDropdown;


// WEBPACK FOOTER //
// ./App/pages/reports/components/dropdown.jsx